import { useTranslation } from 'react-i18next';

/** The YOYO Picks seal: a warm round stamp with a white star (prototype PMARK). */
export function PicksSeal({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={`flex-none ${className}`}>
      <circle cx="12" cy="12" r="12" fill="#7A5B47" />
      <circle
        cx="12"
        cy="12"
        r="9.2"
        fill="none"
        stroke="#FFD93D"
        strokeWidth="1.2"
        strokeDasharray="2 1.6"
      />
      <path
        d="M12 6.4l1.62 3.3 3.64.53-2.63 2.57.62 3.62L12 14.72l-3.25 1.7.62-3.62-2.63-2.57 3.64-.53z"
        fill="#fff"
      />
    </svg>
  );
}

/** Seal plus "友友精选" (prototype `.pmark`; `small` on cards). */
export default function PicksMark({ small = false }: { small?: boolean }) {
  const { t } = useTranslation('picks');
  return (
    <span
      className={`inline-flex items-center font-ui font-semibold text-brown ${
        small ? 'gap-[5px] text-[12px]' : 'gap-1.5'
      }`}
    >
      <PicksSeal className={small ? 'h-4 w-4' : 'h-5 w-5'} />
      {t('name')}
    </span>
  );
}
